import {FC} from 'react';
import clsx from 'clsx';
import Icon from 'components/Icon';
import LinkButton from 'components/LinkButton';
import TableStatic from 'components/Table/TableStatic';
import {t} from 'ttag';
import {boolToIconString} from 'utils/functions';
import {notificationEmployeeTable} from '../styles.module.css';
import {Employee, User} from '../types';

type EmployeeProps = {employee: Employee; user: User};

const MemberTable: FC<EmployeeProps> = ({employee, user}) => (
    <TableStatic
        className={clsx(
            notificationEmployeeTable,
            'mt-6 mb-8 w-full min-w-[720px]',
        )}
        hasStripes={true}
        id="member-table"
    >
        <TableStatic.Header>
            <TableStatic.HeaderRow>
                <TableStatic.Column colSpan={2}>
                    {user.partner} - {employee.email}
                </TableStatic.Column>
                <TableStatic.Column className="flex justify-end">
                    {user.permissions.canEditNotifications.allowed && (
                        <LinkButton
                            href={window.Urls.team_member_notifications_edit_react_view(
                                employee.mid,
                            )}
                            kind="secondary"
                            size="xs"
                        >
                            {t`Edit Notification Settings`}
                        </LinkButton>
                    )}
                </TableStatic.Column>
            </TableStatic.HeaderRow>
        </TableStatic.Header>
        <TableStatic.Body>
            <TableStatic.Row>
                <TableStatic.Cell />
                <TableStatic.Cell className="text-center whitespace-nowrap">
                    {t`I../My..`}
                </TableStatic.Cell>
                <TableStatic.Cell className="text-center whitespace-nowrap">
                    {t`My team../My Team's..`}
                </TableStatic.Cell>
            </TableStatic.Row>
            {employee.settings.map((setting) => (
                <TableStatic.Row key={setting.displayName}>
                    <TableStatic.Cell>{setting.displayName}</TableStatic.Cell>
                    <TableStatic.Cell>
                        {setting.isEmailMyActivityEnabled !== undefined && (
                            <Icon
                                icon={boolToIconString(
                                    setting.isEmailMyActivityEnabled,
                                )}
                                size="base"
                            />
                        )}
                    </TableStatic.Cell>
                    <TableStatic.Cell>
                        {setting.isEmailTeamActivityEnabled !== undefined &&
                            setting.name !== 'daily_summary' &&
                            setting.name !==
                                'document_approval_request_received' &&
                            setting.name !==
                                'scheduled_sending_order_reminder' && (
                                <Icon
                                    icon={boolToIconString(
                                        setting.isEmailTeamActivityEnabled,
                                    )}
                                    size="base"
                                />
                            )}
                    </TableStatic.Cell>
                </TableStatic.Row>
            ))}
        </TableStatic.Body>
    </TableStatic>
);

export default MemberTable;
